/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DashboardStackedMonthlyVar } from './DashboardStackedMonthlyVar';
import {
  DashboardStackedMonthlyVarFromJSON,
  DashboardStackedMonthlyVarFromJSONTyped,
  DashboardStackedMonthlyVarToJSON,
} from './DashboardStackedMonthlyVar';

/**
 *
 * @export
 * @interface DashboardStackedMonthlyVars
 */
export interface DashboardStackedMonthlyVars {
  /**
   *
   * @type {number}
   * @memberof DashboardStackedMonthlyVars
   */
  count: number;
  /**
   *
   * @type {Array<DashboardStackedMonthlyVar>}
   * @memberof DashboardStackedMonthlyVars
   */
  results: Array<DashboardStackedMonthlyVar>;
}

/**
 * Check if a given object implements the DashboardStackedMonthlyVars interface.
 */
export function instanceOfDashboardStackedMonthlyVars(value: object): value is DashboardStackedMonthlyVars {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function DashboardStackedMonthlyVarsFromJSON(json: any): DashboardStackedMonthlyVars {
  return DashboardStackedMonthlyVarsFromJSONTyped(json, false);
}

export function DashboardStackedMonthlyVarsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DashboardStackedMonthlyVars {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    results: (json['results'] as Array<any>).map(DashboardStackedMonthlyVarFromJSON),
  };
}

export function DashboardStackedMonthlyVarsToJSON(value?: DashboardStackedMonthlyVars | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    results: (value['results'] as Array<any>).map(DashboardStackedMonthlyVarToJSON),
  };
}
